var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp1St(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 51",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 12.02,50.00 C 12.02,50.00 22.02,50.00 22.02,50.00 22.02,50.00 22.01,1.01 22.01,1.01 22.01,1.01 1.02,4.01 1.02,4.01 1.02,4.01 1.01,9.99 1.01,9.99 1.01,9.99 12.01,10.01 12.01,10.01 12.01,10.01 12.02,50.00 12.02,50.00 Z M 16.04,27.01 C 16.04,27.01 13.01,30.00 13.01,30.00 13.01,30.00 13.00,27.00 13.00,27.00 13.00,27.00 16.01,24.02 16.01,24.02 16.01,24.02 17.98,24.01 17.98,24.01 17.98,24.01 21.03,26.99 21.03,26.99 21.03,26.99 21.01,30.01 21.01,30.01 21.01,30.01 18.00,27.01 18.00,27.01 18.00,27.01 16.04,27.01 16.04,27.01 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp1St);
export default __webpack_public_path__ + "static/media/mp1st.4766dd935d8d8a5712d7dc8cba8f3022.svg";
export { ForwardRef as ReactComponent };